import React from 'react';
import { string } from 'prop-types';
import SVG from 'react-inlinesvg';

const baseSvgIconsDir = '/media/svg/icons';
const toAbsoluteUrl = pathname => process.env.PUBLIC_URL + pathname;

const SvgIcon = ({ name }) => {
  const url = React.useMemo(
    () => toAbsoluteUrl(`${baseSvgIconsDir}/${name}.svg`),
    [name]
  );

  return <SVG src={url} />;
};

SvgIcon.propTypes = { name: string };

export default SvgIcon;
